import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useTheme } from '@material-ui/styles';
import PropTypes from 'prop-types';

import {
    Text,
    Avatar,
    CalendarIcon,
    ContainedButton,
    DeleteIcon,
    IconButton,
    Tag,
    Span,
} from '../index';

import { StyledCard, StyledCardContent } from './style';

import { SESSION_COLORS, SESSION_TYPE } from '../../constant/index.js';

/*
    Notification type
    staff
        - CHECKED_IN
        - REMINDER
        - SESSION_ENDED
        - WELCOME
        - PASSWORD_RESET
    
    patient
        - QUEUE
        - SKIP_QUEUE
        - MISS_CALL
        - NEW_SESSION
        - SESSION_UPDATED
        - REMINDER
        - READY_TO_CHECK_IN
        - SESSION_ENDED
        - SESSION_CANCELLED
        - WELCOME
        - PASSWORD_RESET
*/

export const NotificationCard = ({ role, data, readNotification, onDelete, onDetail }) => {
    const theme = useTheme();
    const Today = dayjs().format('DD-MM-YYYY');
    const notiDate = dayjs(data?.session?.date).format('DD-MM-YYYY');

    const [title1, setTitle1] = useState('');
    const [title2, setTitle2] = useState('');
    const [time, setTime] = useState('');
    const [description, setDescription] = useState('');
    const [descriptionSpan, setDescriptionSpan] = useState('');

    useEffect(() => {
        if (role === 'patient') {
            switch (data.type) {
                case 'NEW_SESSION':
                case 'SESSION_UPDATED':
                case 'REMINDER':
                    setTitle1('You have an appointment!');
                    setTitle2(`Activity name - ${data?.session?.meet?.name}`);
                    setTime(
                        `${
                            Today === notiDate ? 'Today, ' : `${notiDate}, `
                        } ${data?.session?.startTime.slice(0, 5)} - ${data?.session?.endTime.slice(
                            0,
                            5
                        )}`
                    );
                    return;
            }
        }

        if (role === 'staff') {
            switch (data.type) {
                case 'NEW_SESSION':
                case 'SESSION_UPDATED':
                case 'REMINDER':
                    setTitle1('You have an appointment!');
                    setTitle2(`Activity name - ${data?.meet?.name}`);
                    setTime(
                        `${
                            Today === notiDate ? 'Today, ' : `${notiDate}, `
                        } ${data?.meet?.startTime.slice(0, 5)} - ${data?.meet?.endTime.slice(0, 5)}`
                    );
                    return;
            }
        }

        switch (data.type) {
            case 'WELCOME':
                setTitle1('Welcome to Friday!');
                setDescription(
                    'We have please you finish your personal information as your client will reach to know you better.'
                );
                return;
            case 'PASSWORD_RESET':
                setTitle1('Your password has been changed.');
                setTime(
                    `${
                        dayjs().isSame(dayjs(data.createdAt), 'date')
                            ? 'Today, '
                            : `${dayjs(data.createdAt).format('D MMM YYYY')}, `
                    } ${dayjs(data.createdAt).format('HH:mm')}`
                );
                return;

            case 'READY_TO_CHECK_IN':
                setTitle2('The session is ready to Check in.');
                setDescription(
                    'If you are ready for check-up with your provider, Please check-in to reserve the queue.'
                );
                setTime(
                    `${
                        Today === notiDate ? 'Today, ' : `${notiDate}, `
                    } ${data?.session?.startTime.slice(0, 5)}`
                );
                return;
            case 'SESSION_ENDED':
                setTitle1('Your session finished!');
                setTitle2(`Activity name - ${data?.session?.meet?.name}`);
                setTime(
                    `${
                        Today === notiDate ? 'Today, ' : `${notiDate}, `
                    } ${data?.session?.startTime.slice(0, 5)}`
                );
                return;
            case 'SESSION_CANCELLED':
                setTitle1('Your session has been cancelled!');
                setTitle2(`Activity name - ${data?.session?.meet?.name}`);
                setTime(
                    `${
                        Today === notiDate ? 'Today, ' : `${notiDate}, `
                    } ${data?.session?.startTime.slice(0, 5)}`
                );
                return;
            case 'QUEUE':
                setTitle1('Only two queues left before you.');
                setDescription(
                    `It’s almost your turn. Please prepared. 
                        The provider will call you in a few minutes.`
                );
                return;
            case 'SKIP_QUEUE':
                setTitle1('Your queues has been skipped!');
                setDescription(`Your queues has been skipped from session`);
                setDescriptionSpan(`Activity name - ${data?.session?.meet?.name}`);
                setTime(dayjs(data.createdAt).format('HH:mm'));
                return;
            case 'MISS_CALL':
                setTitle1('You have missed call!');
                setDescription(`You have missed call from session`);
                setDescriptionSpan(`Activity name - ${data?.session?.meet?.name}`);
                setTime(dayjs(data.createdAt).format('HH:mm'));
                return;
        }
    }, [role, data]);

    return (
        <StyledCard
            style={{ position: 'relative', padding: '15px' }}
            onClick={() =>
                readNotification({
                    id: data?.id,
                    owner: data?.owner,
                    isRead: data?.isRead,
                })
            }
        >
            {onDelete && (
                <IconButton
                    onClick={() => onDelete(data?.id)}
                    style={{ position: 'absolute', right: '5px', top: '5px' }}
                >
                    <DeleteIcon fill="gray2" width="18px" height="18px" />
                </IconButton>
            )}
            <StyledCardContent>
                <div style={{ display: 'flex', columnGap: '15px' }}>
                    <div style={{ width: '8px' }}>
                        {!data?.isRead && (
                            <div
                                style={{
                                    backgroundColor: theme.palette.common.purple,
                                    width: '100%',
                                    height: '40px',
                                    borderRadius: '8px',
                                }}
                            />
                        )}
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                            rowGap: '10px',
                        }}
                    >
                        {title1 && (
                            <Text $fontSize="14px" $bold>
                                {title1}
                            </Text>
                        )}
                        {role === 'patient' &&
                            (data.type === 'NEW_SESSION' ||
                                data.type === 'SESSION_UPDATED' ||
                                data.type === 'REMINDER' ||
                                data.type === 'READY_TO_CHECK_IN') && (
                                <div style={{ display: 'flex', columnGap: '10px' }}>
                                    <Avatar
                                        alt={data?.session?.meet?.staff?.user?.fullname}
                                        src={
                                            data?.session?.meet?.staff?.user?.avatar?.url
                                                ? `${data?.session?.meet.staff.user?.avatar?.url}`
                                                : null
                                        }
                                        $avatarSize="40px"
                                        $borderRadius="16px"
                                        style={{ marginTop: '5px' }}
                                    />
                                    <div>
                                        <Text $bold>
                                            {data?.session?.meet?.staff?.user?.fullname}
                                        </Text>

                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <CalendarIcon fill="purple" />
                                            <Text
                                                $color="purple"
                                                style={{ marginLeft: '5px' }}
                                                $fontSize="12px"
                                            >
                                                {time}
                                            </Text>
                                        </div>
                                    </div>
                                </div>
                            )}

                        {role === 'staff' && data.type === 'CHECKED_IN' && (
                            <div style={{ display: 'flex', columnGap: '10px' }}>
                                <Avatar
                                    alt={data?.patient?.user?.fullname}
                                    src={
                                        data?.patient?.user?.avatar?.url
                                            ? `${data.patient.user?.avatar?.url}`
                                            : null
                                    }
                                    $avatarSize="40px"
                                    $borderRadius="16px"
                                />
                                <div style={{ paddingBottom: '3px' }}>
                                    <Text $bold>
                                        {!data?.patient?.user
                                            ? 'Inactive'
                                            : data?.patient?.user?.fullname}
                                    </Text>

                                    <Text $color="purple" $fontSize="12px">
                                        Already Checked In!
                                    </Text>
                                </div>
                            </div>
                        )}

                        {description && (
                            <Text $fontSize="14px" $color="gray2">
                                {description}{' '}
                                {descriptionSpan && <Span $color="black">{descriptionSpan}</Span>}
                            </Text>
                        )}

                        {((role === 'patient' &&
                            (data.type === 'SESSION_ENDED' || data.type === 'SESSION_CANCELLED')) ||
                            (role === 'staff' &&
                                (data.type === 'NEW_SESSION' ||
                                    data.type === 'SESSION_UPDATED' ||
                                    data.type === 'REMINDER' ||
                                    data.type === 'SESSION_ENDED'))) && (
                            <Tag
                                $backgroundColor={
                                    SESSION_COLORS[
                                        data?.session ? data?.session?.meet.type : data?.meet?.type
                                    ]
                                }
                                style={{ height: '15px' }}
                            >
                                <Text
                                    $fontSize="10px"
                                    $color="white"
                                    style={{ textTransform: 'uppercase' }}
                                >
                                    {
                                        SESSION_TYPE[
                                            data?.session
                                                ? data?.session?.meet.type
                                                : data?.meet?.type
                                        ]
                                    }
                                </Text>
                            </Tag>
                        )}

                        {title2 && (
                            <Text $fontSize="14px" $bold>
                                {title2}
                            </Text>
                        )}

                        {role === 'patient' &&
                            (data.type === 'NEW_SESSION' ||
                                data.type === 'SESSION_UPDATED' ||
                                data.type === 'REMINDER') && (
                                <Tag
                                    $backgroundColor={SESSION_COLORS[data?.session?.meet?.type]}
                                    style={{ height: '15px' }}
                                >
                                    <Text
                                        $fontSize="10px"
                                        $color="white"
                                        style={{ textTransform: 'uppercase' }}
                                    >
                                        {SESSION_TYPE[data?.session?.meet?.type]}
                                    </Text>
                                </Tag>
                            )}
                        {(data.type === 'SESSION_ENDED' ||
                            data.type === 'SESSION_CANCELLED' ||
                            data.type === 'PASSWORD_RESET' ||
                            data.type === 'SKIP_QUEUE' ||
                            data.type === 'MISS_CALL') && (
                            <Text $color="purple" style={{ marginLeft: '5px' }} $fontSize="12px">
                                {time}
                            </Text>
                        )}
                    </div>
                </div>
                {(data.type === 'READY_TO_CHECK_IN' ||
                    data.type === 'SESSION_ENDED' ||
                    data.type === 'WELCOME') && (
                    <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'center' }}>
                        <ContainedButton
                            $height="32px"
                            onClick={() => {
                                readNotification({
                                    id: data?.id,
                                    owner: data?.owner,
                                    isRead: data?.isRead,
                                });
                                onDetail(data);
                            }}
                            style={{ maxWidth: '300px' }}
                            disabled={
                                data.type === 'READY_TO_CHECK_IN' &&
                                !dayjs().isBetween(
                                    dayjs(data?.session?.date)
                                        .set({
                                            hour: data?.session?.startTime.split(':')[0],
                                            minute: data?.session?.startTime.split(':')[1],
                                        })
                                        .subtract(10, 'minute'),
                                    dayjs(data?.session?.date).set({
                                        hour: data?.session?.endTime.split(':')[0],
                                        minute: data?.session?.endTime.split(':')[1],
                                    }),
                                    'minute',
                                    '()'
                                )
                            }
                        >
                            {data.type === 'WELCOME'
                                ? 'Complete your profile'
                                : data.type === 'READY_TO_CHECK_IN'
                                ? 'Check in'
                                : 'View report'}
                        </ContainedButton>
                    </div>
                )}
            </StyledCardContent>
        </StyledCard>
    );
};

NotificationCard.propTypes = {
    role: PropTypes.string.isRequired,
    data: PropTypes.object,
    readNotification: PropTypes.func,
    onDelete: PropTypes.func,
    onDetail: PropTypes.func,
};
